/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon27Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M822 152H202c-27.61 0-50 22.39-50 50v620c0 27.61 22.39 50 50 50h368.05c-.04-.79-.06-1.59-.06-2.39V744.93c0-49.58 40.19-89.76 89.76-89.76 49.58 0 89.76 40.19 89.76 89.76v124.68c0 .8-.02 1.6-.06 2.39H822c27.61 0 50-22.39 50-50V202c0-27.61-22.39-50-50-50M719.59 572.87c0 33.05-26.79 59.84-59.84 59.84s-59.84-26.79-59.84-59.84 26.79-59.84 59.84-59.84 59.84 26.79 59.84 59.84"
        }
      ></path>
    </svg>
  );
}

export default Icon27Icon;
/* prettier-ignore-end */
